// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2c6eae53","455":"fe90a272"}[chunkId] + ".chunk.js";
};